import axios from 'axios';
import config from 'config';

const instance = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

instance.interceptors.request.use(
  request => {
    const token = localStorage.getItem('token');
    request.headers = {
      ...request.headers,
      Authorization: token || '',
    };
    return request;
  },
  error => Promise.reject(error),
);

export default instance;
